import {Component, Input, EventEmitter, Output, OnChanges} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Constants} from '../../constants';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.css']
})

export class CreditCardComponent implements OnChanges {

  @Input('creditCardGroup') public creditCardForm: FormGroup;
  public card = 'credit.png';

  rawCard: string = "";

  isAmex: boolean = false;

  @Output()
  rawCardChange: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  isAmexChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnChanges() {}

  onKeyup() {
    let cardNumber = this.creditCardForm.value.CardNumber.replace(/\D/g, '');
    if (cardNumber.length > 16) {
      cardNumber = cardNumber.substring(0, cardNumber.length - 1);
    }

        this.isAmex = false;

    switch (cardNumber) {
      case String(cardNumber.match(Constants.AMEX_REGEX)):
        this.card = 'amex.png';
        this.isAmex = true;
        break;
      case String(cardNumber.match(Constants.DINERS_REGEX)):
        this.card = 'diners.png';
        break;
      case String(cardNumber.match(Constants.DISCOVER_REGEX)):
        this.card = 'discover.png';
        break;
      case String(cardNumber.match(Constants.VISA_REGEX)):
        this.card = 'visa.png';
        break;
      case String(cardNumber.match(Constants.MASTERCARD_REGEX)):
        this.card = 'mastercard.png';
        break;
      case null:
        this.card = 'credit.png';
        break;
      default:
        this.card = 'credit.png';
        break;

    }
    this.rawCardChange.emit(this.rawCard);
    this.isAmexChange.emit(this.isAmex);
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/credit-card/credit-card.component.ts